import { render } from "./SectionPU.vue?vue&type=template&id=01f8447a&scoped=true"
import script from "./SectionPU.vue?vue&type=script&lang=js"
export * from "./SectionPU.vue?vue&type=script&lang=js"

import "./SectionPU.vue?vue&type=style&index=0&id=01f8447a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f8447a"]])

export default __exports__